'use client';
import React__default from 'react';
import PropTypes from 'prop-types';
import { RadioRow, Radio, RadioLabel } from './RadioButton.styles.js';
import { RADIO_SIZES } from './RadioButton.constants.js';

var RadioButton = function RadioButton(_ref) {
  var id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? RADIO_SIZES.REGULAR : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  return React__default.createElement(RadioRow, {
    $disabled: disabled,
    "data-testid": testId
  }, React__default.createElement(Radio, {
    $size: size,
    type: "radio",
    id: id,
    value: value,
    "aria-checked": checked,
    checked: checked,
    disabled: disabled,
    onChange: onChange
  }), React__default.createElement(RadioLabel, {
    $size: size,
    $disabled: disabled,
    htmlFor: id
  }, label));
};
RadioButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(RADIO_SIZES)),
  testId: PropTypes.string,
  value: PropTypes.string.isRequired
};

export { RadioButton };
//# sourceMappingURL=RadioButton.js.map
